const primitiveColors = {
  neutral: {
    100: "#F9FAFB",
    200: "#ECEDF1",
    300: "#D0D5DD",
    400: "#707783",
    450: "#404856",
    500: "#101828",
  },
  red: {
    100: "#FEE4E2",
    200: "#FDA29B",
    300: "#F04438",
    400: "#B42318",
    500: "#7A271A",
  },
  yellow: {
    100: "#FEF0C7",
    200: "#FED384",
    300: "#FBA60A",
    400: "#B44606",
    500: "#632501",
  },
  green: {
    100: "#D1FADF",
    200: "#6CE9A6",
    300: "#11AB63",
    400: "#027A48",
    500: "#054F31",
  },
  blue: {
    100: "#E0EAFC",
    200: "#7DA6F2",
    300: "#1961E7",
    400: "#0D45AC",
    500: "#012870",
  },
  purple: {
    100: "#F6EEFF",
    200: "#A173D4",
    300: "#5A01BC",
    400: "#360171",
    500: "#1D003F",
  },
  basic: {
    black: "#000000",
    white: "#FFFFFF",
  },
} as const;

const semanticColors = {
  foreground: {
    default: primitiveColors.neutral[500],
    muted: primitiveColors.neutral[400],
    onInverse: primitiveColors.neutral[100],
    disabled: primitiveColors.neutral[300],
    success: primitiveColors.green[400],
    warning: primitiveColors.yellow[400],
    danger: primitiveColors.red[400],
    info: primitiveColors.blue[300],
    primaryAction: primitiveColors.blue[300],
    onPrimaryAction: primitiveColors.basic.white,
    selected: primitiveColors.blue[500],
  },
  background: {
    default: primitiveColors.neutral[100],
    disabled: primitiveColors.neutral[200],
    success: primitiveColors.green[100],
    warning: primitiveColors.yellow[100],
    danger: primitiveColors.red[100],
    info: primitiveColors.blue[100],
    surface: primitiveColors.basic.white,
    selected: primitiveColors.blue[100],
  },
  border: {
    default: primitiveColors.neutral[300],
    muted: primitiveColors.neutral[200],
    inverse: primitiveColors.neutral[100],
    disabled: primitiveColors.neutral[200],
    focus: primitiveColors.blue[300],
    success: primitiveColors.green[300],
    warning: primitiveColors.yellow[300],
    danger: primitiveColors.red[300],
    info: primitiveColors.blue[300],
  },
} as const;

export const color = {
  ...primitiveColors,
  ...semanticColors,
} as const;

export type ColorTokens = typeof color;
